import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

export const Tooltip = styled(ReactTooltip)`
width: 30%;
`;
